export default "__VITE_ASSET__iFo95Y2r__"